export default _values => {
  const errors: Record<string, any> = {}

  return errors
}
